import React from 'react';
import useBanner from './hooks/useBanner';
import AcquisitionBanner from './AcquisitionBanner';

const Container: React.FC = () => {
  const banner = useBanner();

  if (!banner) return null;

  return <AcquisitionBanner banner={banner} />;
};

export default Container;
